import { DOWNLOAD_URL, MANUAL_URL } from '../../shared/site-config'
import { navigate } from '../hooks/useHashRoute'

const features = [
  { number: '01', title: '대량 작업', description: '키워드와 광고 작업을 한 화면에서 빠르게 정리합니다.' },
  { number: '02', title: '반복 작업 자동화', description: '자주 반복되는 편집 과정을 줄여 핵심 판단에 집중합니다.' },
  { number: '03', title: '키워드 확장', description: '검색어 데이터를 바탕으로 새로운 키워드 후보를 확인합니다.' },
  { number: '04', title: '통계 시각화', description: '월·성별·디바이스·연령대별 노출 흐름을 비교합니다.' },
]

export default function HomePage() {
  return (
    <>
      <section className="hero section-container">
        <div className="hero-copy">
          <span className="eyebrow">NAVER ADS WORKFLOW</span>
          <h1>
            검색광고 작업을
            <br />더 단순하게.
          </h1>
          <p>
            DSM Editor는 반복적인 키워드 관리와 데이터 확인을 한곳에 모아 작업 시간을 줄여줍니다.
          </p>
          <div className="hero-actions">
            <a className="button button-primary" href={DOWNLOAD_URL}>
              Windows 다운로드
            </a>
            <button className="button button-secondary" onClick={() => navigate('keyword-tool')}>
              키워드 통계 보기
            </button>
          </div>
        </div>
        <div className="hero-panel" aria-label="DSM Editor 핵심 정보">
          <div className="hero-panel-top">
            <span>DSM Editor</span>
            <span className="status-dot">사용 가능</span>
          </div>
          <div className="metric-block">
            <strong>무료</strong>
            <span>현재 제공 버전</span>
          </div>
          <div className="mini-bars" aria-hidden="true">
            {[34, 52, 43, 71, 60, 84, 75].map((height, index) => (
              <i key={index} style={{ height: `${height}%` }} />
            ))}
          </div>
        </div>
      </section>

      <section className="feature-section section-container">
        <div className="section-heading">
          <span className="eyebrow">FEATURES</span>
          <h2>필요한 기능만 또렷하게</h2>
        </div>
        <div className="feature-grid">
          {features.map((feature) => (
            <article className="feature-card" key={feature.number}>
              <span>{feature.number}</span>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="cta-section section-container">
        <div>
          <span className="eyebrow">GET STARTED</span>
          <h2>설치하고 바로 시작하세요.</h2>
          <p>별도 구독 없이 현재 버전을 사용할 수 있습니다.</p>
        </div>
        <div className="cta-actions">
          <a className="button button-primary" href={DOWNLOAD_URL}>다운로드</a>
          <a className="button button-ghost" href={MANUAL_URL} target="_blank" rel="noreferrer">사용 설명서</a>
        </div>
      </section>
    </>
  )
}
